export var beige100 = {right:'$_3IWu0',left:'$yrEDH',top:'$_3BmNK'};
export var white = {right:'$_1G9aj',left:'$_3PrVC',top:'$_1LcuY'};